


























import inputMixin from 'library/mixins/input-mixin'
export default

	mixins: [ inputMixin ]

	props:
		name: String
		label: String
		value: Boolean

		# Loading state is used in flyout menu
		loading: Boolean

	computed:
		# Auto-generate unique ID for accessibility
		checkboxId: -> @name or "checkbox-#{@_uid}"

	methods:

		# Handle clicks
		onClick: ->
			return if @loading
			@state = !@state
			@$emit 'click', @state

